var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: _vm.appointmentViewClassList,
      attrs: { "data-qa": "appointment_club_view" },
    },
    [
      _c("ClubBaseLayout", {
        attrs: { "pdf-data": _vm.pdfData, "use-centered-slot-data": "" },
        scopedSlots: _vm._u(
          [
            {
              key: "club-base-layout-body",
              fn: function () {
                return [
                  _vm.viewState === _vm.viewSteps.appProgress
                    ? _c("ClubAppointmentPreloader")
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.viewState === _vm.viewSteps.appError
                    ? _c("ClubAppointmentError", {
                        on: _vm._d({}, [
                          _vm.eventClubReturnFromErrorView,
                          _vm.handleReturnFromErrorView,
                        ]),
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "club-error-html",
                              fn: function () {
                                return [
                                  _c("div", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.currentErrorStore.description
                                      ),
                                    },
                                  }),
                                ]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          1144401922
                        ),
                      })
                    : _vm.viewState === _vm.viewSteps.payFailed
                    ? _c("ClubAppointmentFailed", {
                        attrs: { "coupon-request-id": _vm.couponRequest.id },
                        on: _vm._d({}, [
                          _vm.eventClubClickPayment,
                          _vm.handleEventClickPayment,
                        ]),
                      })
                    : _vm.viewState === _vm.viewSteps.appWithOffer
                    ? _c("ClubPendingPayment", {
                        attrs: {
                          "card-price": _vm.couponRequest.cardPrice,
                          "coupon-request-id": _vm.couponRequest.id,
                          "has-email": !!_vm.couponRequest.email,
                          "life-time-seconds":
                            _vm.couponRequest.lifeTimeSeconds,
                          "total-price": _vm.couponRequest.totalPrice,
                        },
                        on: {
                          "club:prepayment": _vm.handleEventClubPrepayment,
                          "club:countdown-expired":
                            _vm.handleEventCountdownExpired,
                          "club:send-email-success":
                            _vm.handleEventSendEmailSuccess,
                          "club:click-payment": _vm.handleEventClickPayment,
                        },
                      })
                    : _vm.viewState === _vm.viewSteps.appWithoutOffer
                    ? _c("ClubTimeoutExpired", {
                        attrs: {
                          "doctor-page-url": _vm.doctorPageUrl,
                          "full-price": _vm.couponRequest.fullPrice,
                          "is-cancel": _vm.isCancelByExpired,
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.viewState === _vm.viewSteps.appWithoutOffer &&
            !_vm.isCancelByExpired
              ? {
                  key: "club-base-layout-prepend-footer",
                  fn: function () {
                    return [
                      _c("SuccessDetail", {
                        style: _vm.appointmentSuccessDetailStyleList,
                        attrs: {
                          "detail-appointment-link": _vm.detailAppointmentLink,
                          "town-url": _vm.townUrl,
                        },
                        on: {
                          "club:redirect-to-medtochka":
                            _vm.handleEventRedirectToMedtochka,
                        },
                      }),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }